import React from 'react'
import { UploadDocumentIcon } from './icons/Icons'

interface DragDropAreaProps {
  isDragging: boolean
  targetHeight?: number
  message?: string
}

export const DragDropArea: React.FC<DragDropAreaProps> = ({
  isDragging,
  targetHeight,
  message
}) => {
  if (!isDragging) return null

  return (
    <div
      className="w-full flex flex-col justify-center items-center rounded-xl min-h-[124px] p-2 gap-2 bg-drag"
      style={{
        border: '1px dashed var(--drag-border)',
        height: targetHeight && targetHeight > 0 ? `${targetHeight}px` : undefined
      }}>
      <UploadDocumentIcon size={48} className="text-primary" />
      <p className="text-sm text-primary">{message}</p>
    </div>
  )
}
